(() => {
  const regularAtcForm = document.querySelector("product-form form");
  const stickyAtc = document.querySelector(".js-stciky-atc");
  const trueBuyButton = document.querySelector(".product-form .product-form__submit");
  const compareAtPriceElem = stickyAtc.querySelector(".product-price-block__compare-at-price");
  const priceElem = stickyAtc.querySelector(".product-price-block__price");
  const variantImg = document.querySelector(".js-sticky-atc__product-image");
  const variantTitle = document.querySelector(".js-sticky-atc__product-title");
  const productVariantsParent = document.querySelector(".js-product-variants-parent");
  const percentageElem = stickyAtc.querySelector(".js-product-price-block-percentage");

  const stickyBuyButton = document.querySelector(".js-stciky-atc-button");

  const handleStickyAtcVisibility = () => {
    const isBelow = (element) => {
      const rect = element.getBoundingClientRect();
      return rect.top < window.innerHeight;
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting && isBelow(entry.target)) {
          stickyAtc.classList.add("visible");
        } else {
          stickyAtc.classList.remove("visible");
        }
      });
    });

    if (regularAtcForm) {
      observer.observe(regularAtcForm);
    }
  };

  const handleAddToCart = () => {
    stickyBuyButton.addEventListener("click", function () {
      const submitEvent = new Event("submit", { cancelable: true });
      regularAtcForm.dispatchEvent(submitEvent);
    });
  };

  const changePrice = (newPrice, newCompareAtPrice) => {
    const formatPrice = (priceInCents) => {
      return new Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR" }).format(priceInCents / 100);
    };

    const newPercentage = Math.round(((newCompareAtPrice - newPrice) / newCompareAtPrice) * 100);

    const showCompare = newPercentage >= 5;

    priceElem.textContent = formatPrice(newPrice);

    if (compareAtPriceElem && newCompareAtPrice && newCompareAtPrice > newPrice && showCompare) {
      compareAtPriceElem.textContent = formatPrice(newCompareAtPrice);
      compareAtPriceElem.classList.remove("hidden");
      priceElem.classList.add("--discounted");
    } else {
      compareAtPriceElem.classList.add("hidden");
      priceElem.classList.remove("--discounted");
    }

    if (percentageElem && newPercentage >= 5) {
      percentageElem.textContent = newPercentage + " %";
      percentageElem.classList.remove("hidden");
    } else {
      percentageElem.classList.add("hidden");
    }
  };

  const changeVariantImg = (featuredImage) => {
    variantImg.src = featuredImage.src;
    variantImg.srcset = featuredImage.src;
  };

  const changeVariantTitle = (name) => {
    variantTitle.textContent = `${name}`;
  };

  const changeStickyButton = () => {
    setTimeout(() => {
      if (trueBuyButton.hasAttribute("disabled")) {
        stickyBuyButton.setAttribute("disabled", "");
      } else {
        stickyBuyButton.removeAttribute("disabled");
      }
      stickyBuyButton.querySelector("span").innerText = trueBuyButton.querySelector("span").innerText;
    }, "1500");
  };

  function variantSelectsCallback(event) {
    const checkedInput = event.target;
    if (checkedInput.checked) {
      const scriptElement = document.querySelector(
        `script[type="application/json"][data-resource="${checkedInput.id}"]`
      );
      if (scriptElement) {
        const jsonContent = scriptElement.textContent;
        const parsedData = JSON.parse(jsonContent);
        if (!parsedData) {
          return;
        }
        const { price, compare_at_price, name } = parsedData;
        changePrice(price, compare_at_price);
        changeVariantTitle(name);
        changeStickyButton();
        if (parsedData.featured_image) {
          changeVariantImg(parsedData.featured_image);
        }
      }
    }
  }

  if (productVariantsParent) {
    productVariantsParent.addEventListener("change", (event) => {
      variantSelectsCallback(event);
    });
  }

  const init = () => {
    handleStickyAtcVisibility();
    handleAddToCart();
    changeStickyButton();
  };

  init();
})();


